export default "__VITE_ASSET__DrEv6jjy__"